import { render } from "./DebugConsole.vue?vue&type=template&id=6a95e5b4&scoped=true"
import script from "./DebugConsole.vue?vue&type=script&lang=js"
export * from "./DebugConsole.vue?vue&type=script&lang=js"

import "./DebugConsole.vue?vue&type=style&index=0&id=6a95e5b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a95e5b4"],['__file',"src/components/DebugConsole.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a95e5b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a95e5b4', __exports__)) {
    api.reload('6a95e5b4', __exports__)
  }
  
  module.hot.accept("./DebugConsole.vue?vue&type=template&id=6a95e5b4&scoped=true", () => {
    api.rerender('6a95e5b4', render)
  })

}


export default __exports__